import { HTTPService as Srv } from '@services';

// export const $complaint_save = async (
// 	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
// 	{ name = '' || null, text = '' || null, phone = 0 || null, ...body }, // => body
// ) =>
// 	await Srv.handler({
// 		service: async () =>
// 			await Srv.POST('complaint/save', {
// 				name,
// 				text,
// 				phone,

// 				...body,
// 			}),
// 		onOK,
// 		onFail,
// 		onStatus,
// 		...handler,
// 	});

export const $complaint_save = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ code = '' || null, text = '' || null, cellphone = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST(
				'complaint/save',
				{
					code,
					text,
					cellphone,

					...body,
				},
				{},
				'v2',
			),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $complaint_fetch_all = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ from = 0 || null, to = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('complaint/fetch/all', {
				from,
				to,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $complaint_fetch_id = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('complaint/fetch/id', {
				id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});

export const $complaint_delete = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ id = 0 || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('complaint/delete', {
				id,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});
